"use client";

import { c as _c } from "react/compiler-runtime";
import AppWalletsComponent from "@/components/app-wallets/AppWallets";
import { useSetTitle } from "@/contexts/TitleContext";
import styles from "@/styles/Home.module.scss";
export default function AppWallets() {
  const $ = _c(1);
  useSetTitle("App Wallets | Tools");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <main className={styles.main}><AppWalletsComponent /></main>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}